const loadScrollEvents = () => {
    const experienceScrollDown = document.querySelector('.experience-scroll-down')

    if (experienceScrollDown) {
        experienceScrollDown.addEventListener('click', () => {
            scrollToLocation('.page-experience-carousel', 'down')
        })
    }

    const experienceNavLinks = document.querySelectorAll('.experience-nav-list li a')

    for (let i = 0; i < experienceNavLinks.length; i++) {
        experienceNavLinks[i].addEventListener('click', event => {
            event.preventDefault()
            const id = event.target.href.split('#')[1]
            const locationId = `#${id}`

            if (document.querySelector(locationId).getBoundingClientRect().top > 0) {
                scrollToLocation(locationId, 'down')
            } else {
                scrollToLocation(locationId, 'up')
            }
        })
    }

    const scrollToLocation = (location, direction) => {
        const scrollInterval = direction === 'down' ? 30 : -30

        const timer = setInterval(() => {
            window.scrollBy(0, scrollInterval)

            const topBound = document.querySelector(location).getBoundingClientRect().top

            if (direction === 'down') {
                if (topBound <= 60) clearInterval(timer)
            } else {
                if (topBound >= 60) clearInterval(timer)
            }
        }, 5)
    }

    const isInViewport = element => {
        const rect = element.getBoundingClientRect()
        return (rect.bottom >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight))
    }

    const removeAllActiveClasses = () => {
        for (let i = 0; i < experienceNavLinks.length; i++) {
            experienceNavLinks[i].classList.remove('active')
        }
    }

    const experienceMenu = document.querySelector('.experience-nav-links')

    if (experienceMenu) {
        window.addEventListener('scroll', () => {
            for (let i = 0; i < experienceNavLinks.length; i++) {
                const anchor = experienceNavLinks[i].href.split('#')[1]
                const element = document.getElementById(anchor)
                if (isInViewport(element)) {
                    removeAllActiveClasses()
                    experienceNavLinks[i].classList.add('active')
                }
            }
        })
    }
}

export default loadScrollEvents



// WEBPACK FOOTER //
// ./js/scrollEvents.js